// extracted by mini-css-extract-plugin
export default {"wrapperInputForm":"InputForm_wrapperInputForm__kNtUY","input":"InputForm_input__aWa2K","errors":"InputForm_errors__2mUkm"};